export var SuggestionLanguages = /*#__PURE__*/ function(SuggestionLanguages) {
    SuggestionLanguages["scala"] = "scala";
    SuggestionLanguages["python"] = "python";
    SuggestionLanguages["sql"] = "sql";
    return SuggestionLanguages;
}({});
export const ExtensionToLanguage = {
    scala: 'scala',
    py: 'python',
    sql: 'sql',
    js: 'javascript',
    json: 'json',
    xml: 'xml',
    yml: 'yaml',
    md: 'markdown',
    txt: 'plaintext'
};
export const LanguageToExtension = Object.fromEntries(Object.entries(ExtensionToLanguage).map(([ext, lang])=>[
        lang,
        ext
    ]));
export var FileType = /*#__PURE__*/ function(FileType) {
    FileType["SPEC"] = "Spec";
    FileType["UNKNOWN"] = "Unknown";
    FileType["TEST"] = "Test";
    FileType["UTIL"] = "Util";
    return FileType;
}({});
export var FileOperation = /*#__PURE__*/ function(FileOperation) {
    FileOperation["ADD"] = "ADD";
    FileOperation["DELETE"] = "DELETE";
    FileOperation["UPDATE"] = "UPDATE";
    return FileOperation;
}({});
export var CompletionItemKind = /*#__PURE__*/ function(CompletionItemKind) {
    CompletionItemKind[CompletionItemKind["Variable"] = 4] = "Variable";
    CompletionItemKind[CompletionItemKind["Function"] = 1] = "Function";
    CompletionItemKind[CompletionItemKind["Operator"] = 11] = "Operator";
    return CompletionItemKind;
}({});
export var CompletionItemInsertTextRule = /*#__PURE__*/ function(CompletionItemInsertTextRule) {
    CompletionItemInsertTextRule[CompletionItemInsertTextRule["InsertAsSnippet"] = 4] = "InsertAsSnippet";
    return CompletionItemInsertTextRule;
}({});
export var MarkerSeverity = /*#__PURE__*/ function(MarkerSeverity) {
    MarkerSeverity[MarkerSeverity["Error"] = 8] = "Error";
    MarkerSeverity[MarkerSeverity["Warning"] = 4] = "Warning";
    MarkerSeverity[MarkerSeverity["Info"] = 2] = "Info";
    MarkerSeverity[MarkerSeverity["Hint"] = 1] = "Hint";
    return MarkerSeverity;
}({});
export var SpecFunctionType = /*#__PURE__*/ function(SpecFunctionType) {
    SpecFunctionType["function"] = "function";
    SpecFunctionType["operation"] = "operation";
    SpecFunctionType["udf"] = "udf";
    SpecFunctionType["columnFunction"] = "columnFunction";
    SpecFunctionType["macro"] = "macro";
    return SpecFunctionType;
}({});
